import axios from 'axios';

export const KNPService = {
  async getKNP(pagination) {
    const { page, perPage } = pagination;
    const res = await axios.get('knp/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },
  async createKNP(data) {
    const res = await axios.post('knp/', data);

    if (res.status === 201) {
      return true;
    }
    return Promise.reject();
  },
  async updateKNP(data, id) {
    const res = await axios.put(`knp/${id}/`, data);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
  async deleteKNP(id) {
    const res = await axios.delete(`knp/${id}/`);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
};
